import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Coupon, CouponQueryResponse} from './_models'
import {getToken} from '../../../../auth/core/AuthHelpers'

const API_URL = process.env.REACT_APP_API_URLS

const getCoupon = (query: string): Promise<CouponQueryResponse> => {
  return axios
    .get(`${API_URL}/coupons/query?${query}`, getToken())
    .then((d: AxiosResponse<CouponQueryResponse>) => {
      
      return d.data
    })
}

const createCoupon = (data: any) => {
  return axios.post(`${API_URL}/coupons/addCoupon`, data, getToken()).then((response: any) => response.data)
}

const updateCoupon = (data: any, id: any) => {
  return axios
    .put(`${API_URL}/coupons/updateCoupon/${id}`, data, getToken())
    .then((response: any) => {
      
      return response.data
    })
}
const deleteCoupon = (id: any) => {
  return axios.put(`${API_URL}/coupons/deleteCoupon/${id}`, {}, getToken()).then((response: any) => {
    
    return response.data
  })
}

const getCouponById = (id: any) => {
  return axios.get(`${API_URL}/coupons/viewCoupon/${id}`, getToken()).then((response: any) => response.data)
}

export {getCoupon, createCoupon, updateCoupon, deleteCoupon, getCouponById}
